import { useEffect } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import { usePermission } from '@/hooks/usePermission'
import { cn } from '@/utils/cn'

export function DeveloperLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  // The developer console spans all workspaces; the backend requires the platform DEVELOPER role.
  const { isDeveloper, isLoading } = usePermission()

  useEffect(() => {
    if (!isLoading && !isDeveloper) {
      navigate('/dashboard', { replace: true })
    }
  }, [isDeveloper, isLoading, navigate])

  if (!isDeveloper) {
    return null
  }

  const items = [
    { label: 'Overview', href: '/developer' },
    { label: 'Workspaces', href: '/developer/workspaces' },
    { label: 'Users', href: '/developer/users' },
    { label: 'Analytics', href: '/developer/analytics' },
  ]

  return (
    <div className="space-y-6">
      <div className="border-b border-neutral-200">
        <nav className="flex flex-wrap gap-2 pb-3">
          {items.map((item) => {
            const isActive = location.pathname === item.href || location.pathname.startsWith(`${item.href}/`)
            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive ? 'bg-primary-100 text-primary-900' : 'text-neutral-600 hover:bg-neutral-100'
                )}
              >
                {item.label}
              </Link>
            )
          })}
        </nav>
      </div>
      <Outlet />
    </div>
  )
}